export default function creditCardInputDirective() {
  'ngInject';
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function ($scope, $element, $attrs, ctrl) {

      function setType(type){
        $scope.$eval(`${$attrs.creditCardInputType} = '${type}'`);
      }

      function correctType() {
        if (ctrl.$ccEagerType) {
          if (ctrl.$ccEagerType.match(/Visa|American Express|Discover|Master Card/)) {
            setType(ctrl.$ccEagerType);
            return true;
          }
        }
        else
          return false;
      }

      ctrl.$validators.matchCardType = function () {
        return correctType();
      };
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/creditCardInput.directive.js
 **/